/* unplugin-vue-components disabled */import { render } from "./EmptyKeywords.vue?vue&type=template&id=a67d69f6"
const script = {}

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__